var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AccountPropertySection',_vm._b({attrs:{"autocomplete":"address-level1","placeholder":_vm.t('settings', 'Your city')}},'AccountPropertySection',_vm.location,false,true))
}
var staticRenderFns = []

export { render, staticRenderFns }